import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { useObservationTypes } from '@/hooks/api'

type ObservationTypesProps = {
  value?: string
  onChange: (value: string | undefined) => void
  placeholder?: string
}

export const ObservationTypesSelect = ({
  value,
  onChange,
  placeholder,
}: ObservationTypesProps): JSX.Element => {
  const { data: observationTypes } = useObservationTypes({ limit: 1000 })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={observationTypes?.results?.map(
        ({ id, name }) =>
          ({
            label: name,
            value: id.toString(),
          } as SearchAutocompleteOption)
      )}
      placeholder={placeholder}
      sort={true}
      fieldSx={{ width: 280 }}
    />
  )
}
